const OPP_STATUS = {
    ACTIVE: "نشط",
    COMPLETED: "مكتمل",
    DELETED: "محذوف",
    PREACTIVE: "متاح للحجز",
    HIDDEN: "غير مدرجة"
}

export default OPP_STATUS;